import { render, staticRenderFns } from "./ThgCustomerAccount.vue?vue&type=template&id=cb706e6c&scoped=true"
import script from "./ThgCustomerAccount.vue?vue&type=script&lang=ts"
export * from "./ThgCustomerAccount.vue?vue&type=script&lang=ts"
import style0 from "./ThgCustomerAccount.vue?vue&type=style&index=0&id=cb706e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb706e6c",
  null
  
)

export default component.exports